<div class="table-wrapper">
  <div class="table-sub-wrapper">
    <table *ngIf="sorting" mat-table [dataSource]="dataSource" class="table mat-elevation-z8 bold" matSort (matSortChange)="sortData($event)">
      <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-th-block">{{'WM_TECH_POOL.' + title+ '.' + col | uppercase | translate}}</div>
        </th>

        <ng-container *ngIf="col === 'status'; else elseSortTemplate">
          <td mat-cell *matCellDef="let element">{{('WM_TECH_POOL.' + element[col]) | uppercase | translate}}</td>
        </ng-container>
        <ng-template #elseSortTemplate>
          <td mat-cell *matCellDef="let element">{{element[col] | translate}}</td>
        </ng-template>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <table *ngIf="!sorting" mat-table [dataSource]="dataSource" class="table mat-elevation-z8 bold">
      <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-th-block">{{'WM_TECH_POOL.' + title + '.' + col | uppercase | translate}}</div>
        </th>

        <ng-container *ngIf="title === 'payouts' && col === 'actions'; else elseTemplate">
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element['actions'] === 'cancel'; else cantCancel">
              <button mat-raised-button color="pool-button-bg-primary" (click)="cancelPayoutHandle(element['id'])" type="submit" class="submit-button">
                {{ 'WM_TECH_POOL.PAYOUTS.CANCEL' | translate }}
              </button>
            </ng-container>
            <ng-template #cantCancel> {{ element[col] || '-'}} </ng-template>
          </td>
        </ng-container>
        <ng-container *ngIf="title === 'payouts' && col === 'status'; else elseTemplate">
          <td mat-cell *matCellDef="let element">
            <span class="mining-pool-status">
              <span
                class="status-circle"
                [ngClass]="{
                'green': element.status === 'processed' || element.status === 'verified',
                'red': element.status === 'rejected' || element.status === 'failed' || element.status === 'canceled' || element.status === 'unverified',
                'orange': element.status === 'pending' || element.status === 'processing',
                'yellow' : element.status === 'sent',
              }"
              ></span>
              <span> {{("WM_TECH_POOL.PAYOUTS.STATUS." + element[col]) | uppercase | translate}} </span>
            </span>
          </td>
        </ng-container>

        <ng-container *ngIf="title === 'accessTokens' && col === 'label'; else elseTemplate">
          <td mat-cell *matCellDef="let element">{{ element[col] || '-'}}</td>
        </ng-container>
        <ng-container *ngIf="title === 'accessTokens' && col === 'token'; else elseTemplate">
          <td mat-cell *matCellDef="let element">
            <div class="acc-token-url">
              <a target="_blank" class="table-link" href="{{element[col]}}">{{element[col] | cutString}}</a>
              <wm-libs-copy-loader [style.width]="'50px'" [valueForCopy]="element[col]" color="green"></wm-libs-copy-loader>
            </div>
          </td>
        </ng-container>
        <ng-container *ngIf="title === 'accessTokens' && col === 'status'; else elseTemplate">
          <td mat-cell *matCellDef="let element">
            <div class="flex">
              <mat-slide-toggle [checked]="element[col] === true" (change)="sendToggleAccessTokenStatusEvent($event, element)" class="wm-toggle"></mat-slide-toggle>
            </div>
          </td>
        </ng-container>
        <ng-container *ngIf="title === 'accessTokens' && col === 'permissions'; else elseTemplate">
          <td mat-cell *matCellDef="let element">
            <div class="access-token-permission-wrapper">
              <div class="access-token-permission" *ngFor="let permission of element[col]; let last = last">
                <span>{{ 'WM_TECH_POOL.ACCESSTOKEN.PERMISSIONS.' + permission | uppercase | translate}}</span>
                <span *ngIf="!last">,&nbsp;</span>
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container *ngIf="title === 'accessTokens' && col === 'actions'; else elseTemplate">
          <td mat-cell *matCellDef="let element">
            <div class="acc-token-actions">
              <svg
                class="tableSvgIconsPool cursor-pointer"
                (click)="sendEditAccessTokenPermissionsEvent(element)"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L10 12.5858L10 14H11.4142L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289ZM16.8787 2.87868C18.0503 1.70711 19.9497 1.70711 21.1213 2.87868C22.2929 4.05025 22.2929 5.94975 21.1213 7.12132L12.5355 15.7071C12.348 15.8946 12.0936 16 11.8284 16H9C8.44772 16 8 15.5523 8 15L8 12.1716C8 11.9064 8.10536 11.652 8.29289 11.4645L16.8787 2.87868ZM6 6C5.44772 6 5 6.44772 5 7V18C5 18.5523 5.44772 19 6 19H17C17.5523 19 18 18.5523 18 18V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13V18C20 19.6569 18.6569 21 17 21H6C4.34315 21 3 19.6569 3 18V7C3 5.34315 4.34315 4 6 4H11C11.5523 4 12 4.44772 12 5C12 5.55229 11.5523 6 11 6H6Z"
                  fill="#353535"
                />
              </svg>
              <svg class="tableSvgIconsPool cursor-pointer" (click)="sendRemoveAccessTokenEvent(element.id)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8 4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6H18.9897C18.9959 5.99994 19.0021 5.99994 19.0083 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H19.9311L19.1301 19.2137C19.018 20.7837 17.7117 22 16.1378 22H7.86224C6.28832 22 4.982 20.7837 4.86986 19.2137L4.06888 8H4C3.44772 8 3 7.55228 3 7C3 6.44772 3.44772 6 4 6H4.99174C4.99795 5.99994 5.00414 5.99994 5.01032 6H8V4ZM6.07398 8L6.86478 19.0712C6.90216 19.5946 7.3376 20 7.86224 20H16.1378C16.6624 20 17.0978 19.5946 17.1352 19.0712L17.926 8H6.07398ZM14 6H10V4H14V6ZM10 10C10.5523 10 11 10.4477 11 11V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V11C9 10.4477 9.44772 10 10 10ZM14 10C14.5523 10 15 10.4477 15 11V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V11C13 10.4477 13.4477 10 14 10Z"
                  fill="#848484"
                />
              </svg>
            </div>
          </td>
        </ng-container>
        <ng-container *ngIf="title === 'workers'; else elseTemplate">
          <td mat-cell *matCellDef="let element">{{'WM_TECH.POOL' + element[col]}}</td>
        </ng-container>
        <ng-container *ngIf="col === 'createdAt_updatedAt'; else elseTemplate">
          <td mat-cell *matCellDef="let element" [style.white-space]="'pre-line'">{{element['createdAt_updatedAt']}}</td>
        </ng-container>
        <ng-container *ngIf="col === 'address'; else elseTemplate">
          <td mat-cell *matCellDef="let element" class="cell-cut-string row">
            <span *ngIf="element[col]" [matTooltip]="element[col]" matTooltipPosition="right" #tooltip="matTooltip" (click)="tooltip.toggle()">{{element[col] | cutString}}</span>
            <span *ngIf="!element[col]">-</span>
            <wm-libs-copy-loader *ngIf="element[col]" [valueForCopy]="element[col]"></wm-libs-copy-loader>
          </td>
        </ng-container>
        <ng-container *ngIf="col === 'transactionId'; else elseTemplate">
          <td mat-cell *matCellDef="let element" class="cell-cut-string row">
            <a
              *ngIf="element[col]"
              [matTooltip]="element[col]"
              matTooltipPosition="right"
              [matTooltipDisabled]="(isMobile$ | async) === true"
              class="transactionId__link"
              target="_blank"
              href="https://www.blockchain.com/explorer/search?search={{element['transactionId']}}"
              >{{element['transactionId'] | cutString}}</a
            >
            <span *ngIf="!element[col]">-</span>
            <wm-libs-copy-loader *ngIf="element[col]" [valueForCopy]="element[col]"></wm-libs-copy-loader>
          </td>
        </ng-container>
        <ng-container *ngIf="col === 'status'; else elseTemplate">
          <td mat-cell *matCellDef="let element">{{('WM_TECH_POOL.' + title + '.STATUS.' + element[col]) | uppercase | translate}}</td>
        </ng-container>
        <ng-template #elseTemplate>
          <td mat-cell *matCellDef="let element" class="uppercase">{{ element[col] || '-'}}</td>
        </ng-template>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div *ngIf="!dataSource?.length" class="no-table-data">
      <ng-container *ngIf="title !== 'accounts'">
        <img *ngIf="!isDarkMode$" src="assets/images/dashboard/empty-data/{{ title }}.svg" alt="empty {{ title }}" />
        <img *ngIf="isDarkMode$" src="assets/images/dashboard/empty-data/{{ title }}-dark.svg" alt="empty {{ title }}" />
      </ng-container>

      {{"WM_TECH_POOL." + title.toUpperCase() + ".EMPTY_DATA" | translate}}
    </div>
  </div>

  <mat-paginator
    *ngIf="pagination && dataSource?.length"
    [length]="countData"
    [pageSizeOptions]="[10, 20, 50]"
    [pageSize]="count"
    [pageIndex]="pageIndex"
    (page)="pageChange.emit($event)"
    showFirstLastButtons
  ></mat-paginator>
</div>
